<template>
  <Authenticated>
    <div class="orders">
      <div class="all-orders">
        <h1>All Orders</h1>
        <div class="filter-buttons">
          <button id="all-btn" @click="filterSite('all')">All</button>
          <button id="city-btn" @click="filterSite('city')">City</button>
          <button id="nev-btn" @click="filterSite('nev')">NEV</button>
        </div>
        <div class="tickets">
          <OrderTicket v-for="order in filteredOrders" :key="order._id" :order="order" @filter="filterSite(this.site)" @update-orders="getOrders" />
          <p v-if="filteredOrders.length === 0">No available orders</p>
        </div>
      </div>
      <div class="open-orders">
        <h1>Current Orders</h1>
        <div class="tickets">
          <OrderTicket v-for="order in selectedOrders" :key="order._id" :order="order" @update-orders="getOrders" />
          <p v-if="selectedOrders.length === 0">You have not selected any orders to deliver</p>
        </div>
      </div>

      <div class="past-orders">
        <h1>Past Orders</h1>
        <div class="tickets">
          <OrderTicket v-for="order in orders.filter((o) => o.delivery_data.status === 'delivered')" :key="order._id" :order="order" @update-orders="getOrders" />
          <p v-if="orders.filter((o) => o.delivery_data.status === 'delivered').length === 0">No orders have been marked as delivered yet</p>
        </div>
      </div>
    </div>
  </Authenticated>
</template>

<script>
import Authenticated from "./_layouts/Authenticated.vue";
import OrderTicket from "./OrderTicket.vue";
import { api } from "@monolith/helpers";
import { mapGetters } from "vuex";

export default {
  name: "OrdersPage",
  components: {
    Authenticated,
    OrderTicket,
  },
  data() {
    return {
      allOrders: [],
      openOrders: [],
      filteredOrders: [],
      site: "all",
    };
  },
  computed: {
    ...mapGetters({
      orders: "orders",
      selectedOrders: "selectedOrders",
      avaliableOrders: "avaliableOrders",
    }),

    todaysDate() {
      let date = new Date();
      return date.toISOString().split("T")[0];
    },

    yesterdaysDate() {
      let date = new Date();
      date.setDate(date.getDate() - 1);
      return date.toISOString().split("T")[0];
    },
  },

  watch: {},

  async mounted() {
    await this.getOrders();
    const allBtn = document.querySelector("#all-btn");
    allBtn.classList.add("selected");
  },

  methods: {
    async getOrders() {
      let allOrders = await api.get_delivery_orders(localStorage.getItem("company"), this.todaysDate, this.yesterdaysDate);
      console.log("Fetched orders:", allOrders);
      this.$store.dispatch(
        "updateOrders",
        allOrders.map((order) => order.value),
      );
      this.filteredOrders = this.avaliableOrders;
    },

    filterSite(siteChosen) {
      this.site = siteChosen;
      if (siteChosen === "all") {
        this.filteredOrders = this.avaliableOrders;
        const btns = document.querySelectorAll(".filter-buttons button");
        btns.forEach((b) => b.classList.remove("selected"));
        const allBtn = document.querySelector("#all-btn");
        if (allBtn) allBtn.classList.add("selected");
      } else if (siteChosen === "city") {
        this.filteredOrders = this.avaliableOrders.filter((order) => order.location === siteChosen);
        const btns = document.querySelectorAll(".filter-buttons button");
        btns.forEach((b) => b.classList.remove("selected"));
        const cityBtn = document.querySelector("#city-btn");
        if (cityBtn) cityBtn.classList.add("selected");
      } else if (siteChosen === "nev") {
        this.filteredOrders = this.avaliableOrders.filter((order) => order.location === siteChosen);
        const btns = document.querySelectorAll(".filter-buttons button");
        btns.forEach((b) => b.classList.remove("selected"));
        const nevBtn = document.querySelector("#nev-btn");
        if (nevBtn) nevBtn.classList.add("selected");
      }
    },
  },
};
</script>

<style scoped lang="scss">
@use "@monolith/styles";

.orders {
  display: flex;
  flex-direction: row;
  gap: 2rem;

  .all-orders {
    flex: 1;

    h1 {
      margin: 0;
      color: var(--text-colour);
    }

    .filter-buttons {
      display: flex;
      margin: 1rem 0;

      button {
        padding: 0.5rem 1rem;
        margin: 0.25rem;
        border-radius: 0.5rem;
        background-color: var(--secondary-colour);
        color: var(--text-colour);
        border: none;
        cursor: pointer;

        &.selected {
          background-color: var(--action-colour);
        }
      }
    }
  }

  .open-orders {
    flex-direction: column;

    .user {
      margin: 0.8rem 0;
    }
  }

  .past-orders {
    flex-direction: column;
    margin-bottom: 5rem;
  }

  .tickets {
    background-color: var(--secondary-colour);
    display: flex;
    flex-direction: column;
    gap: 1rem;
    overflow: scroll;
    border-radius: 0.5rem;
    padding: 0.5rem;
    min-height: 20vh;
    overflow-x: hidden;
  }
}

@media only screen and (orientation: portrait) {
  .orders {
    flex-direction: column;
    margin: 0;
  }
}
</style>
